import {
  VuexModule,
  Module,
  Mutation,
  Action,
  getModule
} from "vuex-module-decorators";

import store from "@/store";
import Service from "@/services/AsesmenKeperawatanGadarService";
import { isEmpty } from "lodash";

interface AsesmenKeperawatan {
  id: number;
  pasien_rm: number;
  register_id: number;
  content: any;
  signed_at: Date;
}

@Module({
  dynamic: true,
  namespaced: true,
  store,
  name: "asesmen-perawat-gadar"
})
class AsesmenKeperawatanGadarStore extends VuexModule {
  loading = false;
  asesmen: AsesmenKeperawatan = null;
  registerId: string = null;

  @Mutation
  SET_ASESMEN(val) {
    this.asesmen = val;
  }

  @Mutation
  SET_LOADING(val: boolean) {
    this.loading = val;
  }

  @Mutation
  SET_REGISTER_ID(val) {
    this.registerId = val == null ? null : String(val);
  }

  @Action
  reset(): void {
    this.SET_ASESMEN(null);
    this.SET_REGISTER_ID(null);
  }

  @Action({ rawError: true })
  async getByRegister(registerId): Promise<void> {
    this.SET_LOADING(true);

    if (this.registerId !== String(registerId)) {
      this.SET_ASESMEN(null);
    }

    this.SET_REGISTER_ID(registerId);

    const response = await Service.getByRegister(registerId).finally(() => {
      this.SET_LOADING(false);
    });

    if (this.registerId !== String(registerId)) return;

    const data = isEmpty(response.data) ? null : response.data;

    this.SET_ASESMEN(data);
  }
}

export default getModule(AsesmenKeperawatanGadarStore);
